import TagPill from "./tagPill"
import TagSearchField from "./tagSearchField"
import TagPillBundler from "./TagPillBundler.vue"

export { TagPill, TagSearchField }

export default TagPillBundler
